import { Download } from "lucide-react";
import { Meeting } from "@platform/types/platform.types";
import { Button } from "@shared/ui/Button";
import generateICSLinkForMeetingArray from "../utils/generateICSLinkForMeetingArray";

export type Props = {
  onClick?: () => void;
  meetings?: Meeting[];
  eventTitle: string;
  onAddCalendarEvent: (
    meetingId: number | "all",
    calendarType: "google" | "ical"
  ) => void;
};

export function DownloadICSButton({
  onClick,
  meetings,
  eventTitle,
  onAddCalendarEvent,
}: Props) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (!meetings) return;

    const { link, url } = generateICSLinkForMeetingArray({
      meetings,
      eventTitle: eventTitle,
      outputFileName: "pollinator-meeting.ics",
    });

    onAddCalendarEvent("all", "ical");

    link.click();

    URL.revokeObjectURL(url);

    onClick?.();
  };

  return (
    <Button variant="primary" iconComponent={Download} onClick={handleClick}>
      Download All Events (.ics)
    </Button>
  );
}

export default DownloadICSButton;
